import React from "react";

import MentorshipProgramLayout from "../components/mentorshipProgramComp";
import SEO from "../components/seo";
import img1 from "../images/Narendra_Pashuparthy.jpg";
import img2 from "../images/Nida_Sahar.jpg";
import img3 from "../images/Kiran_Bettadapur.jpg";
import img4 from "../images/Sanjeev_Kumar.jpg";
import img5 from "../images/Akshay_Chandrashekar.jpg";
import img6 from "../images/Srikanth_Sheshadri.jpg";
import img7 from "../images/Harish_Closepet.jpg";
import img8 from "../images/Madhavi_Nagouda.jpg";
import img9 from "../images/Neha_Nagaraj.jpg";
import img10 from "../images/Vijayanath_Bhuvanagiri.jpg";
import img11 from "../images/Shiva_Maran.jpg";
import img12 from "../images/Dinesh_Kashyap.jpg";

function MentorshipProgramNetwork() {

  return (
    <MentorshipProgramLayout
    brief="Being one of the earliest institutions in the country, BMS has a mammoth alumni base all over the world and in numerous fields. Our Mentorship program is an attempt to tap into this wealth of knowledge and channelize the same to aid meaningful development of budding talents. We provide a reliable platform and opportunity for 1-on-1 guidance from eminent alumni specific to interests and aspirations. The alumni club will help in building overall personal development relationships with mentors that enables purposeful conversation to reflect on experiences and act upon ideas generated."
  >
  
    <SEO
      title="Mentorship Program:BMSCE Alumni Club"
      keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
    />

  </MentorshipProgramLayout>
  );
}

export default MentorshipProgramNetwork;
